import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52613d06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"padding":"10px 0"} }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: "审批流程",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    direction: "rtl",
    size: 150,
    "custom-class": "logger-drawer",
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      (_ctx.dataList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_timeline, { class: "timeline" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: index,
                    placement: "top",
                    color: index === _ctx.dataList.length-1 ? '#409EFF' : '',
                    timestamp: _ctx.$filters.formatTime(+item.createTime)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", _hoisted_2, _toDisplayString(item.creatorName), 1),
                      _createElementVNode("p", null, _toDisplayString(item.state), 1),
                      _createElementVNode("p", null, _toDisplayString(item.reply), 1)
                    ]),
                    _: 2
                  }, 1032, ["color", "timestamp"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}